import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { AxReloadable } from "../../Lib/AxSystem/AxReloadable";
import { AxLoading } from "../../Limestone/AxLoading/AxLoading";

@ModuleName("ShoppingCartReservationTimer")
export class ShoppingCartReservationTimer implements AxInit, AxReloadable {
    private axLoading: AxLoading;
    private companyDateTime: moment.Moment;
    private countDown: number;

    AxInit(init: any): void {
        this.axLoading = new AxLoading();
        this.loadReservationTimes();
    }

    AxReload(init: any): void {
        clearInterval(this.countDown);
        this.loadReservationTimes();
    }

    // loadReservationTimes
    public loadReservationTimes() {
        const reservationTimeHolders = $('.cartEntryCd');

        for (let i = 0; i < reservationTimeHolders.length; i++) {
            this.axLoading.ShowLoadingIndicator(reservationTimeHolders[i]);
        }

        AxessViewer.ajaxRequest('/api/ShoppingCartReservationTimeApi/getReservationTimes', null, (result: ShoppingCartReservationTimes) => {
            this.companyDateTime = moment(result.CompanyTime, 'YYYY-MM-DD HH:mm');

            this.setCountDownsFromResult(result);
            for (let i = 0; i < reservationTimeHolders.length; i++) {
                this.axLoading.HideLoadingIndicator(reservationTimeHolders[i]);
            }
        }, null);
    }

    // setCountDownsFromResult
    setCountDownsFromResult(result: ShoppingCartReservationTimes) {
        for (let i = 0; i < result.CartEntryReservationTimes.length; i++) {
            this.momentCountDown(result.CartEntryReservationTimes[i].ReservedUntil, '.cartEntryReservationCd_' + result.CartEntryReservationTimes[i].CartEntryId);
        }
    }

    // momentCountDown
    momentCountDown(reservationEndTimeString: string, reservationHolderElem: string) {
        const eventTime = moment(reservationEndTimeString);
        const diffTime = eventTime.diff(this.companyDateTime, 'milliseconds');
        let duration = moment.duration(diffTime, 'milliseconds');
        let interval = 1000;


        let temp = setInterval((x) => {
            let durationNumber = duration.asMilliseconds();
            duration = moment.duration(durationNumber - interval, 'milliseconds');

            if (duration.asMilliseconds() === 0) {
                clearInterval(this.countDown);
                $(reservationHolderElem).html("Reservation expired");
                window.location.reload();
            } else {
                const minutes = duration.minutes() < 10 ? `0${duration.minutes()}` : duration.minutes();
                const seconds = duration.seconds() < 10 ? `0${duration.seconds()}` : duration.seconds();
                $(reservationHolderElem).html(`${duration.hours()}:${minutes}:${seconds}`);
            }
        }, interval);

        this.countDown = temp;
    }
}

export class ShoppingCartReservationTimes {
    CompanyTime: string;
    CartEntryReservationTimes: CartEntryReservationTime[]
}

export class CartEntryReservationTime {
    CartEntryId: number;
    ReservedUntil: string;
}